<template>
  <div class="flex flex-col justify-between text-center">
    <div class="w-full bg-beige-academy-300 text-white text-center uppercase
        tracking-widest uppercare text-md py-4 mb-6 pt-6" v-if="selectedSlot.student">
        {{$t('editingSlots.new')}}
      </div>
    <div class="w-5/6 mx-auto flex flex-col justify-between text-md mb-8 relative font-sans-serif
    text-center">
      <select class="border bg-beige-academy-150 text-black appearance-none outline-none
      rounded-md h-10 px-3"
      v-model="existingSlotToPropose">
        <option v-for="slot in freeConvertedSlots" :key="slot.id" :value="slot">
          <span class="mr-12"> {{slot.day}}: {{slot.start}} - {{slot.end}}
          </span>
        </option>
      </select>
      <div class="pointer-events-none absolute inset-y-0
      right-0 flex items-center px-2 pt-1 text-grey-academy-300">
        <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
          <path d="M9.293 12.95l.707.707L15.657
          8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/>
        </svg>
      </div>
    </div>
    <div class="w-3/4 mx-auto">
    <div class="flex flex-row justify-between mb-6 text-sm mx-auto w-3/4">
      <modal-button @click="$modal.hide('change-lesson')"
      :buttonPlaceholder="$t('bookingSlots.cancel')"
      buttonClass="uppercase" />
     <modal-button @click="saveExistingFreeSlotToPropose(existingSlotToPropose)"
     :buttonPlaceholder="$t('editingSlots.save')"
     buttonClass="uppercase" />
    </div>
    </div>
    <div class="w-full bg-beige-academy-300 text-white text-center uppercase
        tracking-widest text-md py-5 mt-4 mb-6" v-if="selectedSlot.student">
        {{ $t('editingSlots.customize') }}
      </div>
    <div class="md:w-3/4 w-5/6 mx-auto flex flex-col justify-between mb-8">
      <div class="w-3/4 mx-auto flex flex-col justify-between font-sans-serif">
        <div class="mb-2">
          <strong>
            <input type="date" class="border border-grey-academy-150 rounded-md p-1"
              v-model="editedSlot.day">
          </strong>
        </div>
        <div class="mb-2">
          {{$t('bookingSlots.from')}}
            <strong class="mr-4">
              <input type="time" v-model="editedSlot.start"
                class="border border-grey-academy-150 rounded-md p-1">
            </strong>
          {{$t('bookingSlots.to')}}
            <strong>
              <input type="time" v-model="editedSlot.end"
                class="border border-grey-academy-150 rounded-md p-1">
            </strong>
        </div>
        <div class="flex flex-row justify-between mt-6 text-sm">
          <modal-button @click="$modal.hide('change-lesson')"
            :buttonPlaceholder="$t('bookingSlots.cancel')"
            buttonClass="uppercase" />
          <modal-button @click="saveNewSlotToPropose(editedSlot)"
          :buttonPlaceholder="$t('editingSlots.save')"
          buttonClass="uppercase" />
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import axios from 'axios';
import dayjs from 'dayjs';
import StreamFunctionsMixin from '@/mixins/StreamFunctionsMixin';
import DatesConversion from '@/mixins/DatesConversion';
import { mapActions } from 'vuex';
import ModalButton from '../graphics/ModalButton.vue';

export default {
  props: ['selectedSlot', 'freeConvertedSlots', 'slotToEdit', 'savedSlots'],

  components: {
    ModalButton,
  },

  data() {
    return {
      existingSlotToPropose: null,
      editedSlot: this.slotToEdit,
    };
  },

  mixins: [StreamFunctionsMixin, DatesConversion],

  methods: {
    ...mapActions({
      updatedSlots: 'slots/updatedSlots',
    }),

    getDate(day, time) {
      const tzDate = dayjs.tz(`${day}T${time}`, this.choosenTimezone);
      return this.changeDateFormatForCalendarAndDatabase(
        this.convertDateTimezoneForDatabase(tzDate),
      );
    },

    convertSlotForDatabase(slotToConvert) {
      const editedSlotToSave = {
        id: slotToConvert.id,
        start_date: this.getDate(slotToConvert.day, slotToConvert.start),
        end_date: this.getDate(slotToConvert.day, slotToConvert.end),
        duration: 0,
      };
      const start = dayjs(editedSlotToSave.start_date);
      const end = dayjs(editedSlotToSave.end_date);
      editedSlotToSave.duration = end.diff(start, 'minutes');

      return editedSlotToSave;
    },

    saveExistingFreeSlotToPropose(existingSlotToPropose) {
      const convertedSlotToPropose = this.convertSlotForDatabase(existingSlotToPropose);
      axios.post(`/api/slots/pending/${this.selectedSlot.id}?new=false`, convertedSlotToPropose).then(() => {
        this.createNotification('success', this.$t('notifications.changedLessonSent'));
        this.$modal.hide('change-lesson');
        this.updatedSlots(true);
      }).catch(() => {
        this.createNotification('error', this.$t('notifications.errorTryAgain'));
      });
    },

    saveNewSlotToPropose(editedSlot) {
      const convertedSlotToPropose = this.convertSlotForDatabase(editedSlot);

      if (this.checkSlot(convertedSlotToPropose, this.savedSlots)) {
        axios.post(`/api/slots/pending/${this.selectedSlot.id}?new=true`, convertedSlotToPropose).then(() => {
          this.createNotification('success', this.$t('notifications.changedLessonSent'));
          this.$modal.hide('change-lesson');
          this.updatedSlots(true);
        }).catch(() => {
          this.createNotification('error', this.$t('notifications.errorTryAgain'));
        });
      } else {
        this.createNotification('error', this.$t('notifications.overlapDate'));
      }
    },
  },
};
</script>
